import { z } from 'zod';
import { TenantSchema } from '../entities/tenant.js';
// =========================================================
// /v1/tenant (single, scoped to caller) — see docs/api.md §3.3
// =========================================================
// GET /v1/tenant
export const TenantGetResponseSchema = TenantSchema;
// PATCH /v1/tenant
export const TenantPatchRequestSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    logoUrl: z.string().url().nullable().optional(),
    brandColor: TenantSchema.shape.brandColor.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'At least one field required.' });
export const TenantPatchResponseSchema = TenantSchema;
// POST /v1/tenant/logo-upload-url
export const TenantLogoUploadUrlRequestSchema = z.object({
    contentType: z.enum(['image/png', 'image/jpeg', 'image/webp']),
    /** Max 2 MB. */
    sizeBytes: z
        .number()
        .int()
        .positive()
        .max(2 * 1024 * 1024),
});
export const TenantLogoUploadUrlResponseSchema = z.object({
    uploadUrl: z.string().url(),
    objectKey: z.string(),
    publicUrl: z.string().url(),
});
//# sourceMappingURL=tenant.js.map